module.exports = __webpack_public_path__ + "img/pbl02_03.29274e63.jpg";